import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {
    Table,
    SearchButton,
    LightTextButton,
    FilterDropdown,
    SwitchButton,
    ImageStamp,
    TextLink,
    TextInput,
    DocumentButton,
    Status,
    StatusButton,
    Search,
    PageNavigator
} from "components";
import TableSP from "components/Table/TableSP";
import {serviceProviderAction, categoryAction, customersAction, subCategoriesAction} from "redux/actions";
import PackagesPopup from "../popups/Packages/PackagesPopup";
import {useHistory} from "react-router-dom";
import {adminToken, internalSearch} from "../../../helper";
import * as XLSX from "xlsx";
import {Modal} from "@material-ui/core";
import SpNewModal from "../../ServiceProviderNew/SPNewModal";
import SubscriptionModal from "../../Customers/modals/SubscriptionModal";
import axios from "axios";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

const initialFilterState = {
    firstName: "",
    lastName: "",
    mobile: "",
    category: "",
    sub_category: "",
    status: "",
    userId: "",
    city: "",
};

export default function ServiceProviderPanel() {
    // Routers
    const history = useHistory();
    const currentLocation = history.location.pathname;

    const [openModal, setOpenModal] = useState(false)
    const handleOpenModal = () => {
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false)

    const handleOpenSubscriptionModal = () => {
        setOpenSubscriptionModal(true)
    }

    const handleCloseSubscriptionModal = () => {
        setOpenSubscriptionModal(false)
    }

    const [clickedSubscription, setClickedSubscription] = useState(null)

    const [clickedSP, setClickedSP] = useState(null)

    const [value, setValue] = useState(0);

    // States
    const [tableRows, setTableRows] = useState();
    const [editableDetail, setEditableDetails] = useState();
    const [isPopupVisible, setPopupVisible] = useState();

    // Filter States
    const [status, setStatus] = useState("All");
    const [filter, setFilter] = useState('');
    const [searchData, setSearchData] = useState('');
    const [cPage, setCPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [spLoader, setSpLoader] = useState(false);
    const [filterState, setFilterState] = useState(initialFilterState);
    const [listofcat, setListofcat] = useState([]);
    const [listofcity, setListofcity] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedSubCategory, setSelectedSubCategory] = useState();

    // Redux actions
    const dispatch = useDispatch();
    const [serviceProvider, setServiceProvider] = useState([])

    const {categories, subCategories, userRole} = useSelector(state => ({
        // serviceProvider: state.serviceProvider,
        categories: state.categories,
        subCategories: state.subCategories,
        userRole: state.userRole?.filter(role => role.module === "Service Provider")
    }));
    
    useEffect(() => {
        dispatch(subCategoriesAction.get(filterState?.category));
    }, [filterState]);
    

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read")) {
            setSpLoader(true);
            adminToken().then(token => axios
                .get(
                    `${AWS_SERVER_APIS}/allspdatas?per_page=10&page=${cPage}&fname=${(filterState.firstName)?filterState.firstName:''}&lname=${(filterState.lastName)?filterState.lastName:''}&mobile=${(filterState.mobile)?filterState.mobile:''}&status=${(filterState.status)?filterState.status:''}&category=${(filterState.category)?filterState.category:''}&sub_category=${(filterState.sub_category)?filterState.sub_category:''}&userId=${(filterState.userId)?filterState.userId:''}&city=${(filterState.city)?filterState.city:''}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                .then(res => {
                    setServiceProvider(res.data);
                    setListofcat(res.data.categories)
                    setListofcity(res.data.cities)
                    setLastPage(res.data.lastPage);
                    dispatch(serviceProviderAction.get(1,100000000))
                    setSpLoader(false);
                })
            )
        }
    }, [searchData,cPage])

    

    // useEffect(() => {
    //     if (userRole?.find(item => item.privilege === "Read")) {
    //         //dispatch(serviceProviderAction.get(1));
    //         dispatch(categoryAction.get());
    //     }

    //     //return () => dispatch(serviceProviderAction.reset());
    // }, []);

    // const onPageChange = e => {
    //     console.log("e =>", e)
    //     //dispatch(serviceProviderAction.get(e))
    // }

    useEffect(() => {
        let filtered = serviceProvider?.users;
        

        if (!filtered?.length) {
            setTableRows();
            return;
        }

        // filter based on Status
        // if (status !== 'All') {
        //     filtered = filtered?.filter(item => item.status === status.toLowerCase());
        // }
        // filtered = internalSearch(filterState, "userId", filtered);
        // filtered = internalSearch(filterState, "firstName", filtered);
        // filtered = internalSearch(filterState, "lastName", filtered);
        // filtered = internalSearch(filterState, "mobile", filtered);
        // Map table rows
        filtered = filtered?.map(obj => ({
            userId: (
                <TextLink
                    text={obj.userId}
                    onClick={() =>
                        history.push(`/service-providers-new/service-providers/${obj.userId}/profile`)
                    }
                    // onClick={() => {
                    //     setClickedSP({
                    //         id: obj?.userId,
                    //         mobile: obj?.mobile,
                    //         name: obj?.firstName + " " + obj?.lastName,
                    //         categoryID: obj?.categoryID,
                    //         categoryName: categories?.find(item => item.id == obj.categoryID)?.name
                    //     })
                    //     handleOpenModal()
                    // }}
                />
            ),
            firstName: (filter != '')?obj.firstName.toLowerCase().replaceAll(filter.toLowerCase(), '<b>'+filter+'</b>'):obj.firstName,
            lastName: (filter != '')?obj.lastName.toLowerCase().replaceAll(filter.toLowerCase(), '<b>'+filter+'</b>'):obj.lastName,
            picture: <ImageStamp src={obj.picture}/>,
            mobile: (filter != '')?obj.mobile.toLowerCase().replaceAll(filter.toLowerCase(), '<b>'+filter+'</b>'):obj.mobile,
            role: obj.role,
            category: categories?.find(item => item.id == obj.categoryID)?.name,
            city: obj.getcitydetails?.city_name,
            createdAt: `${new Date(obj.createdAt).toLocaleString()}`,
            updatedAt: `${new Date(obj.updatedAt).toLocaleString()}`,
            orgID: (
                <TextLink
                    text={obj.orgID}
                    onClick={() =>
                        history.push(`/organization/organization?id=${obj.orgID}`)
                    }
                />
            ),
            subOrgID: (
                <TextLink
                    text={obj.subOrgID}
                    onClick={() =>
                        history.push(
                            `/organization/sub-organization?orgID=${obj.orgID}&subOrgID=${obj.subOrgID}`
                        )
                    }
                />
            ),
            rating: obj.rating,
            location: obj.location,
            status: (
                <StatusButton
                    title={obj?.status}
                    options={["onboarding", "approved", "rejected"]}
                    onChange={status =>
                        userRole?.find(item => item.privilege === "Update") ? dispatch(serviceProviderAction.changeStatus(obj.userId, status)) : null
                    }
                />
            ),
            documents: (
                <DocumentButton
                    approved={
                        obj?.documents?.filter(doc => doc.status === "approved").length
                    }
                    uploaded={obj?.documents?.filter(doc => doc.documentURL).length}
                    total={obj?.documents?.length}
                    onClick={() =>
                        history.push(`/service-providers-new/service-providers/${obj.userId}/documents`)
                    }
                    // onClick={() => {
                    //     setClickedSP({id: obj?.userId, mobile: obj?.mobile, name: obj?.firstName + " " + obj?.lastName})
                    //     handleOpenModal()
                    //     setValue(5)
                    // }}
                />
            ),
            active: <Status active={obj.active}/>,
            enabled: (
                <SwitchButton
                    enabled={obj.enabled}
                    onClick={
                        userRole?.find(item => item.privilege === "Enable")
                            ? () => dispatch(serviceProviderAction.toggle(obj.userId))
                            : null
                    }
                />
            )
        }));


        //filtered = internalSearch(filterState, "category", filtered);

        setTableRows(filtered);
    }, [serviceProvider, status, filterState]);

    // Search based on category & sub category name
    const onSearch = () => {
        setSearchData({filter});
        setCPage(1);
    };

    // Clear Search
    const clearSearch = () => {
        window.location.reload();
        // setSearchData('');
        // setFilterState(initialFilterState);
    };
   
    
    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "ID",
                sortBy: "userId"
            },
            {
                title: "First Name",
                sortBy: "firstName"
            },
            {
                title: "Last Name",
                sortBy: "lastName"
            },
            {
                title: "Image"
            },
            {
                title: "Contact"
            },
            {
                title: "Role"
            },
            {
                title: "Category"
            },
            {
                title: "City",
                sortBy: "city"
            },
            {
                title: "Created",
                sortBy: "createdAt"
            },
            {
                title: "Updated",
                sortBy: "updatedAt"
            },
            {
                title: "Org"
            },
            {
                title: "Sub Org"
            },
            {
                title: "Rating"
            },
            {
                title: "Location"
            },
            {
                title: "Status"
            },
            {
                title: "Documents"
            },

            {
                title: "Online"
            },

            {
                title: "Enabled"
            }
        ],
        [tableRows]
    );
    const exportDataFunc = () => {
        const rows = tableRows.map(item => {
            return {
                "ID": item.userId.props.text,
                "First Name": item.firstName,
                "Last Name": item.lastName,
                "Contact": item.mobile,
                "Role": item.role,
                "Category": item.category,
                "Org": item.orgID.props.text,
                "Sub Org": item.subOrgID.props.text,
                "Status": item.status.props.text,
                "Rating": item.rating,
                "Location": item.location,
                "Enabled": item.enabled.props.enabled,
                "Created": item.createdAt,
                "Updated": item.updatedAt
            }
        })

        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(workbook, "DataSheet.xlsx");
    }

    return (
        <div>
            <div className={styles.filter}>
                {/* <TextInput
                    search
                    label="Service Provider ID"
                    name="userId"
                    value={filterState?.userId}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                <TextInput
                    search
                    label="First Name"
                    name="firstName"
                    value={filterState?.firstName}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                <TextInput
                    search
                    label="Last Name"
                    name="lastName"
                    value={filterState?.lastName}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                <TextInput
                    search
                    label="Contact"
                    name="mobile"
                    value={filterState?.mobile}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                <TextInput
                    search
                    label="Category"
                    name="category"
                    value={filterState?.category}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />
                <FilterDropdown
                    onChange={e => setStatus(e.target.value)}
                    label="Status"
                    options={["All", "Approved", "Rejected", "Onboarding"]}
                />
                <SearchButton
                    onClick={
                        userRole?.find(item => item.privilege === "Read") ? onSearch : null
                    }
                /> */}

                <TextInput
                    search
                    label="Provider"
                    type="number"
                    name="userId"
                    value={filterState?.userId}
                    style={{width:"100px"}}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />

                <TextInput
                    search
                    label="First Name"
                    name="firstName"
                    value={filterState?.firstName}
                    style={{width:"170px"}}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />

                <TextInput
                    search
                    label="Last Name"
                    name="lastName"
                    style={{width:"170px"}}
                    value={filterState?.lastName}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />

                <TextInput
                    search
                    label="Mobile"
                    name="mobile"
                    style={{width:"170px"}}
                    value={filterState?.mobile}
                    onChange={e =>
                        setFilterState({...filterState, [e.target.name]: e.target.value})
                    }
                />

                <select className="form-control" onChange={e => setFilterState({...filterState, [e.target.name]: e.target.value})} name="city" style={{width:"120px",display:"inline-block"}}>
                    <option value="">-City-</option>
                    {
                        listofcity?.map((city) => {
                            return <option value={city.id}>{city.city_name}</option>;
                        })
                    }
                </select>&nbsp;&nbsp;

                <select className="form-control" onChange={e => setFilterState({...filterState, [e.target.name]: e.target.value})} name="category" style={{width:"120px",display:"inline-block"}}>
                    <option value="">-Category-</option>
                    {
                        listofcat?.map((cat) => {
                            return <option value={cat.id}>{cat.name}</option>;
                        })
                    }
                </select>&nbsp;&nbsp;

                <select className="form-control" onChange={e => setFilterState({...filterState, [e.target.name]: e.target.value})} name="sub_category" style={{width:"120px",display:"inline-block"}}>
                    <option value="">-Sub Category-</option>
                    {
                        subCategories?.map((subcat) => {
                            return <option value={subcat.id}>{subcat.name}</option>;
                        })
                    }
                </select>&nbsp;&nbsp;

                
                <select className="form-control" onChange={e => setFilterState({...filterState, [e.target.name]: e.target.value})} name="status" style={{width:"100px", display:"inline-block"}}>
                    <option value="">-Status-</option>
                    <option value="">Pending</option>
                    <option value="onboarding">Onboarding</option>
                    <option value="approved">Approved</option>
                    <option value="rejected">Rejected</option>
                </select>&nbsp;&nbsp;


                <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={userRole?.find(item => item.privilege === "Read") ? onSearch : null}
                >Search
                </button>&nbsp;&nbsp;

                <button className={'btn btn-info m-auto'} style={{margin: 10}}
                        onClick={clearSearch}
                >Clear
                </button>&nbsp;&nbsp;
                
                {/* {(spLoader)?<button className={'btn btn-primary'}>
                    <span className={'spinner-border spinner-border-sm'}></span>&nbsp;
                    Loading....
                </button>:''} */}
                


                {/* <button className={'btn btn-primary m-auto'} style={{margin: 10}}
                        onClick={exportDataFunc}
                >Export Data
                </button> */}
            </div>

            {/*<Table headers={tableHeaders} data={tableRows} length={serviceProvider?.length} exportData={false}*/}
            {/*/>*/}

            
            <TableSP
                headers={tableHeaders}
                data={(!spLoader)?tableRows:''}
                current={serviceProvider?.pageNumber}
                totalPage={Math.ceil(tableRows?.count / 10)}
                onPageChange=''
                state={filterState !== initialFilterState}
                length={tableRows?.length}
                r_length={serviceProvider?.users?.length}
                t_length={serviceProvider?.count}
                exportData={false}
                spLoader={spLoader}
            />
            
            {(tableRows && !spLoader)?<PageNavigator
                    pageCount={lastPage}
                    currentPage={cPage}
                    onClick={e => {setCPage(e)}}
                />:''}

            {isPopupVisible && (
                <PackagesPopup
                    data={editableDetail}
                    closeModal={() => setPopupVisible(false)}
                />
            )}

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SpNewModal clickedSP={clickedSP} handleCloseModal={handleCloseModal} value={value} setValue={setValue}
                            setClickedSubscription={setClickedSubscription}
                            handleOpenSubscriptionModal={handleOpenSubscriptionModal} spLoader={spLoader}/>
            </Modal>

            <Modal
                open={openSubscriptionModal}
                onClose={handleCloseSubscriptionModal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <SubscriptionModal clickedSubscription={clickedSubscription} handleCloseModal={handleCloseSubscriptionModal}/>
            </Modal>

        </div>
    );
}
